// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3C2hu","item":"PaymentsMobile_item__23wXt","label":"PaymentsMobile_label__3acvw","amount":"PaymentsMobile_amount__l9pcX"};